const cards = {
  cards: 'Credentials',
  search_by_organization_or_site: 'Credential, Assigned user',
  search_by_user: 'Credential',
  add_card: 'New Credential',
  options: 'Options',
  general_information: 'General Information',
  assign_user: 'Assign User',
  assigned_user: 'Assigned User',
  assign_msg: 'Do you want to assign the credential {{ card }} to {{ user }}?',
  assign_reader:
    'Do you want to scan with reader {{ reader }} from site {{ site }}?',
  delete_msg: 'Do you want to delete the credential {{ card }}?',
  unassign_msg:
    'Do you want to unassign {{ user }} from the credential {{ card }}?',
  delete_card_multiple_sites:
    'Note: this credential is associated with multiple sites and will be deleted from all of them.',
  readers: 'Readers',
  scan_card: 'Scan Credential',
  search_devices: 'Search Devices',
  scan_status: 'Scan Status: ',
  enrolled: 'Enrolled',
  discover: 'Discover KPROG',
  use_kprog: 'Use KPROG',
  kprog: 'KPROG',
  table: {
    card: 'CREDENTIAL',
    format: 'FORMAT',
    name: 'NAME',
    state: 'STATUS',
    user_name: 'NAME',
    reader: 'READER',
    site: 'SITE',
  },
  form: {
    display_name: 'Display name',
    facility_code: 'Facility Code',
    card_code: 'Credential Code',
    activation_date: 'Activation Date',
    expiry_date: 'Expiration Date',
    card_format: 'Credential Format',
    card_number_hex: 'Credential Number Hex',
    all: 'All',
    stolen: 'Stolen',
    lost: 'Lost',
    status: 'Status',
    select_a_reader: 'Select a reader',
    csn: 'C.S.N. (printed number)',
    registration_code: 'Registration Code',
  },
  pin_option: {
    not_used: 'Not used',
    start_lockdown: 'Start lockdown',
    stop_lockdLock: 'Stop lockdown',
    lockdown_grant: 'Lockdown grants access',
    area_secured: 'Keep door secured (maintain lockdown)',
  },
  list: {
    column_credential_number: 'Credential number',
    column_csn: 'CSN',
    column_facility_code: 'Facility code',
    column_credential_id: 'Credential ID',
    column_assigned_user: 'Assigned user',
    column_lockdown: 'Lockdown option',
    column_stolen: 'Stolen',
    column_lost: 'Lost',
    lockdown_display: {
      not_used: 'None',
      start: 'Disabled during lockdown',
      stop: 'Stop lockdown',
      grant_access: 'Bypass during lockdown',
      maintain: 'Keep door secured',
    },
    pill_stolen: 'Stolen',
    pill_lost: 'Lost',
  },
};

export default cards;
